module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C251"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "html/images/18_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('p', {
    staticClass: "C345"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("1")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "C287"
  }, [_c('strong', [_vm._v("ON A TRIP TO IKEA")])]), _vm._v(" "), _c('p', {
    staticClass: "C359"
  }, [_vm._v("BRITAIN AND IRELAND")]), _vm._v(" "), _c('p', {
    staticClass: "C251"
  }, [_c('img', {
    staticClass: "img80",
    attrs: {
      "alt": "",
      "src": "html/images/20_1.png"
    }
  })])]), _c('p', {
    staticClass: "C296"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('strong', [_c('em')])]), _c('strong', [_c('em', [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Expect extraordinary plants in ordinary places")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v(".")])])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "P21"
  }, [_vm._v("MY JOURNEY BEGINS in a retail park in Essex, south-east England. Bear with me – I promise this journey will become more exotic. But it was not on a mountain nor in a rainforest that I found the plant that was to change my life. No, no. It was outside IKEA among the coke cans. Here I found my first broomrape: a leafless ghoul that snatched at the roots of other plants, unseen. It had no chlorophyll – not an ounce of it – having forsaken the wholesome photosynthetic existence of its ancestors for a life of crime, stealing strength from its victims. This botanical enigma ignited my curiosity as a child, challenging my notion of how a plant behaved, and even what a plant was. It became my compass.")])]), _c('p', {
    staticClass: "P22"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("On my grandmother’s shelf sat a cherished row of the Victorian illustrator Anne Pratt’s six-volume work describing the flora of Great Britain. When I wasn’t training toads in the garden, setting off squirting cucumbers or ruining a new carpet with paint, I’d spend time poring over these books. One of the musty volumes, describing a tribe of plants ‘parasitic on the roots of other vegetables’, became well-thumbed. Before I knew much about plants, their tawny, leafless forms leaped off the page at me. ‘Many on first looking at it,’ explained Anne, ‘have believed it to be the remains of a flower from which the summer’s sun had withered away all the beauty.’"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/17_Notes#id_100",
      "id": "id_99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" Not me. This group of plants had a curious beauty of its own – and I wanted to find one more than anything.")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("It happened on a family shopping trip in my teens. ‘Stop!’ I shouted from the car, pointing to a bank of shrubbery in the car park. ‘Not again!’ chorused my family as we screeched to a halt. I jumped out to examine it and collect its seeds. My first one. Actually, a whole forest of them: common broomrapes ("), _c('em', [_vm._v("Orobanche minor")]), _vm._v(") growing in their hundreds, on the roots of "), _c('em', [_vm._v("Brachyglottis")]), _vm._v(", an ordinary-looking ornamental shrub. ‘Mr Loudon,’ continued Anne, referring to the Scottish botanist and garden designer ‘says that any of the broomrapes may be made to grow in the garden on furze and broom’. I fancied that I might cultivate them for myself in my parents’ back garden. Reading that common broomrape was partial to the roots of red clovers, this was the host I selected for my garden trial. Only to my disappointment, a year later, my crop failed: not one broomrape emerged. The following year, I tried the experiment again, this time using a potted "), _c('em', [_vm._v("Brachyglottis")]), _vm._v(" shrub – the plant I’d found the broomrape feasting on at IKEA. This time, to my delight, dozens of broomrapes pushed their way up out of the tub like bunches of purple asparagus. Mr Loudon was right about one thing: broomrapes "), _c('em', [_vm._v("can")]), _vm._v(" be grown in the garden; but as to their choice of host, they are far fussier than he had supposed.")]), _vm._v(" "), _c('div', {
    staticClass: "C259"
  }, [_c('p', {
    staticClass: "C258"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('img', {
    staticClass: "img70",
    attrs: {
      "alt": "",
      "src": "html/images/22_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "P24"
  }, [_c('em', [_vm._v("Orobanche minor")]), _vm._v(" var. "), _c('em', [_vm._v("heliophila")]), _vm._v(" growing in a retail park in Essex, south-east England.")])])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('p', {
    staticClass: "P22"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Keeping the results of my early garden experiments steadily in view, I made these curiously illicit parasitic plants the focus of my early career in research. My PhD probed deeper into the secret lives of broomrapes. I set out to understand whether common broomrape was as catholic as the books claimed regarding its choice of host. And so it was – clifftop dangling and golf ball ducking – that my vertiginous quest began. I searched for them all over the place, crawling under fences, over clifftops and appearing in people’s back gardens. An army of enthusiasts mobilised by the Botanical Society of the British Isles sent me samples by post from up and down the country. My mother was persuaded to collect specimens from a churchyard and got caught, trowel in hand, by the curious vicar. We were all knee-deep in broomrapes.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "P22"
  }, [_vm._v("Back in the lab, I grew them in petri dishes, scrutinising their intricacies: their DNA, which plants they would feed from, which they wouldn’t. And I found that seemingly identical populations behave very differently indeed. In fact, they are evolving new species right under our noses. This was my discovery: isolated from one another, broomrapes were silently leading parallel lives in their various haunts, from clifftop turf to golf course roughs, even in IKEA car parks.")])]), _c('div', {
    staticClass: "C259"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('p', {
    staticClass: "C258"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('img', {
    staticClass: "img70",
    attrs: {
      "alt": "",
      "src": "html/images/24_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "P24"
  }, [_c('em', [_vm._v("Orobanche minor")]), _vm._v(" var. "), _c('em', [_vm._v("pseudoamethystea")]), _vm._v(" growing by a golf course in Kent, south-east England.")])])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('p', {
    staticClass: "C298"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("KENT")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "P21"
  }, [_vm._v("I arrive at Dover Priory train station in Kent, on the hottest day of the year, in July. The sea air is filled with the shrill siren of acrobatic gulls and a sharp, sweet smell like salt and vinegar. The seaside town comprises a port and a ribbon of houses nestled at the foot of a pleated white cliff, all presided over by a great grey castle. It has a bustling, purposeful feel, a place where people look distracted. After dumping my bags at the local bed and breakfast, I make my way eagerly towards my destination: the stretch of coastline between Dover and Deal, along which grows one of Britain’s very rarest plants.")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("A few miles from Dover lies the village of Saint Margaret's at Cliffe. Once a well-to-do holiday resort, it feels like it might not have changed a great deal since the 1940s. A steep, green lane pivots its way awkwardly around twisted pines and compact shrubbery mounded by coastal gales, with spiky cordylines poking out. I catch glimpses of manicured lawns and shady dining room windows. Eventually, the narrow lane flattens and peters out into the bay, where a tangle of wild ivy and clematis bleed into a straw-parched lawn.")])]), _c('p', {
    staticClass: "P22"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("The grey sea gently slaps and rakes the orange and grey shingle. The air tastes salty. I crunch my way past suncream-streaked holidaymakers draped along the beach like seals. A woman leans against the breakwater, adjusting a purple flip-flop; another nearby is shaking a towel. Both are as pink as prawns. I reach a quartet of white villas at the far end of the beach. One of these, I read, was a holiday ")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("home called ‘White Cliffs’ owned by the 1940s playwright Noel Coward. Beyond the villas, the bathers vanish and the beach becomes wild. Here the sea has thrown up a curious assortment of flotsam and jetsam including a bundle of creamy mermaids’ purses: the fancifully-named leathery egg cases of the small catshark, along with some chalky cuttlebones. Their curious, shapely forms belong to another world – a hard-cut watery place where creatures go about their business unseen. I pick my way through a messy web of intense-smelling crispy seaweed. Just beyond it I spot a mound of chalky rubble, slumped at the foot of the cliff. This looks promising.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('div', {
    staticClass: "C259"
  }, [_c('p', {
    staticClass: "C258"
  }, [_c('img', {
    staticClass: "img55",
    attrs: {
      "alt": "",
      "src": "html/images/25_1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "P24"
  }, [_vm._v("A ‘mermaid’s purse’, the egg case of a lesser spotted catshark.")])]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("The sun is searing now and a heat haze shimmers on the horizon. I could be in Spain. I scramble up the steep, loose scarp. The constant crash and hiss of the sea seems louder by the cliff. A few metres up, my palms white and dusty, I find a succulent mass of grey-leaved rock samphire sprawling over the rocks. I nibble on a juicy leaf that has a unique salty, spicy taste – with a hint of the smell of furniture polish. Every plant has its own unique fragrance and taste, I’ve discovered, and I like to get to know them (unless they are poisonous). I’ve learned to tell apart identical-looking species of ivy by their smell alone.")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("With glee I spot the first broomrape of the day among the patchy vegetation: a fat spike of carrot broomrape ("), _c('em', [_vm._v("Orobanche minor")]), _vm._v(" subsp. "), _c('em', [_vm._v("maritima")]), _vm._v(") pointing to the sky. Not the plant I’m after, but an exciting find nonetheless. Carrot broomrape was first recorded in Britain in 1845 by the Reverend W. S. Hore from on the cliffs at Whitsand Bay in Cornwall. Since then it has baffled botanists with its superficial similarity to other closely related broomrapes. But its affinity for sea carrots (upon which it feeds), its dark purple stems and the two yellow knots on the lower lip of the flowers are quite distinctive. I bag a sample for a future DNA extraction back in the lab, and make my way back up to the top of the cliffs, the taste of samphire lingering.")])]), _c('div', {
    staticClass: "C259"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('p', {
    staticClass: "C258"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('img', {
    staticClass: "img60",
    attrs: {
      "alt": "",
      "src": "html/images/27_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "P24"
  }, [_c('em', [_vm._v("Orobanche picridis")]), _vm._v(" growing on the White Cliffs of Dover, Kent, south-east England.")])])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('p', {
    staticClass: "P22"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("‘Half-way down, hangs one that gathers samphire; dreadful trade!’ writes Shakespeare in "), _c('em', [_vm._v("King Lear")]), _vm._v(" (Act 4, Scene 6), referring to the dangerous pursuit of gathering the cliff-dwelling rock samphire. But my quest is far more dangerous than a samphire harvest, I discover: picris broomrape ("), _c('em', [_vm._v("O. picridis")]), _vm._v(") is what I’m after, and this predominantly Mediterranean species is a cliffhanger. Britain is the northern limit of its range, where it’s virtually confined to the White Cliffs of Dover and the Isle of Wight. Britain’s rarest native broomrape, this thermophile likes the dry rocky ledges of cliffs that bake in the sun, akin to warm Mediterranean scrub.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "P22"
  }, [_vm._v("Scouring the crumbly edge of the cliffs between Dover and Deal I find a dozen of the pearl-coloured spikes sprouting among the thin grass scorched dry by the hot Kentish sun. I crouch down and examine their features closely. ‘Good’ specimens have blackish stigmas, long, twisted bracts and hairy filaments; there’s no mistaking these. Smaller ones are trickier because they overlap considerably with their more pedestrian cousin, the common broomrape ("), _c('em', [_vm._v("O. minor")]), _vm._v(") that also grows here. I take a little tissue from everything I find. But for the DNA I plan to examine back in the lab, I need more samples: there’s no avoiding it, I need to go over the edge of the cliff.")])]), _c('p', {
    staticClass: "P22"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("The late afternoon sun is still hot. Blue butterflies flutter aimlessly over the clifftop turf to an orchestra of burring crickets. The milky-blue channel glistens. A little meandering path snakes in and out of the briers, tussocky paddocks with horses and clumps of stinking iris ("), _c('em', [_vm._v("Iris foetidissima")]), _vm._v("); I amuse myself by crushing a leaf, the scent of which is just like roast beef. Soon I see the busy Port of Dover stretching out onto the horizon to my left. It looks like an industrial estate of cars, cranes and tubes, sinking into ")]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("the sea. I peer over the great chalky precipice. A long way down, frothy seawater is silently plucking the bouldery foot of the cliff. Dissolved chalk plumes out into the depths, in slow motion, like milky clouds pouring into ink. And there, a few metres below on a rocky ledge, is exactly what I’m looking for: an irresistible clump of ivory-coloured spikes of picris broomrape.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "P22"
  }, [_vm._v("I’m not a qualified climber. I don’t speak the lingo, do the belaying, tie the knots – none of that. But, in a way, I’ve trained my whole life by looking for plants. I inch my way down, my back against the cliff, with clammy palms. "), _c('em', [_vm._v("Don’t look down")]), _vm._v(". Slowly, I edge my way to the shelf. It’s only a foot wide and rather less stable than I’d hoped. However, I can sit on it without too much difficulty, with my legs dangling over the edge. For a magical moment, I’m alone with these special plants, the White Cliffs of Dover above, below and behind me and the Channel stretching out in front of me. No one can even see I’m here – probably just as well because they’d surely call the fire brigade if they could.")])]), _c('p', {
    staticClass: "P22"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("As if reading my mind, a siren startles me. I realise it’s the ferry terminal below. ‘May I have your attention please. This is a security announcement . . .’ reverberates a slow, female voice that echoes about the cliffs. It sounds uncannily like Judi Dench. The spell broken, I set to work, examining, measuring, collecting and scribbling. I twist myself carefully into position so that I may take a photograph or two. ‘If you see something that doesn’t look right . . .’ continues Judi. Probably best to make an exit now in case I’m spotted from the ferry terminal below. I look up to scan the vertical cliff stretching up between me and the path. As I stand, a white stream of chalky debris dislodges noisily from under my feet and vanishes into the abyss. I grab the rock, my palms dripping with sweat. This is a risky business. I reassure myself that since I managed to find a route down here, I can surely get back up without too much difficulty. Out of nowhere, an enormous white gull looms up from underneath me, screaming piercingly. To my horror it tries to extricate me from the cliff! Like something out ")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("of a nightmare, the griffon wheels around me repeatedly, lunging with stabbing orange feet extended like some hideous great raptor zeroing in on its prey. Is this normal behaviour for a seagull? ‘Get "), _c('em', [_vm._v("off")]), _vm._v(" me, you "), _c('em', [_vm._v("bastard")]), _vm._v(",’ I shout, wobbling, and nearly lose my footing. Panicking, I grab a grassy tussock for balance. I scrabble my way up, flinging further flurries of rock. One careful step at a time, I manage to grasp the rock, pulling myself up to the top of the cliff. The gull laughs loudly.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "P22"
  }, [_vm._v("This is extreme botany.")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("Lightheaded, I haul myself back to safety, my palms a mess of chalk, sweat and blood. The gull seems satisfied that I’m no longer trespassing in its domain and circles sulkily away. I dust myself down and head quietly back to the bed and breakfast, telling myself I’ll never do that again. But I do.")]), _vm._v(" "), _c('p', {
    staticClass: "C298"
  }, [_vm._v("MONMOUTHSHIRE")]), _vm._v(" "), _c('p', {
    staticClass: "P21"
  }, [_vm._v("I arrive in South Wales on a soaking wet day in June. The purpose of my visit is to look for a rare form of broomrape ("), _c('em', [_vm._v("O. minor")]), _vm._v(") that has yellow spikes of flowers, crowded atop stout, scaly stems. Examined carefully by only a few botanists, the form I’m after may grow only here, around the docks, and I have a delicious sense of anticipation at the prospect of finding a plant I’ve not seen before.")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("The lane towards the docks smells of warm, wet tarmac. It’s flanked by high grey railings, holding back a forest of buddleia. Above me looms a web of pylons. I spot a woman wandering in the opposite direction, in a pink dressing gown and slippers; an interesting choice of clothing in a rainstorm. Somewhere in the distance, a motorbike revs and roars. I reach the end of the grey lane where a sign warns against fly-tipping next to a messy heap of cans, cigarette packets and various discarded plastic items; close by another sign says, ‘Welcome to the port’.")])]), _c('div', {
    staticClass: "C259"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('p', {
    staticClass: "C258"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('img', {
    staticClass: "img60",
    attrs: {
      "alt": "",
      "src": "html/images/31_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "P24"
  }, [_c('em', [_vm._v("Orobanche minor")]), _vm._v(" var. "), _c('em', [_vm._v("lutea")]), _vm._v(" growing by the docks in Monmouthshire, South Wales.")])])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('p', {
    staticClass: "P22"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("It is not altogether clear where I can and can’t go, but the man at the entrance to the docks doesn’t object to me exploring the area to my left, so I go in. The patchwork of grey, gritty spaces and sandbanks, dissected by a rusty railway track, is covered in an uneven carpet of straw-coloured grasses and ruderal weeds. I note at least 20 different plant species in under ten minutes. Everywhere I wander, the warm damp air is thick with a mélange of buddleia and creosote, all sweet and smoky. I splash my way through black puddles that have sprung up all over the place. After a short while I encounter my first stand of lemon-coloured broomrapes sprouting by the train track, pushing their way out of a sandy patch of rain-beaded grass and clover.")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "P22"
  }, [_vm._v("I get that familiar thrill of finding a plant for the first time, feel it coursing through my system like caffeine. The plants are small and immature, not ripe enough for close examination. I will need to find more. After a good hour of scouring the area, soaking wet and with tar fixed firmly in my nostrils, I head down a roadside track. Lorries flicker in and out of view through the soggy hedge. Then a flash of yellow catches my eye. At last, among silvery sun-bleached crisp packets and cigarette butts, I find a fat, mature broomrape specimen. Its thick, butter-yellow spike glows against the grit and inky weeds. Its flowers are congested and dome-like at the top, just as they should be. I note its location so that I can return to collect its seeds. This isn’t the most salubrious of places to go plant hunting. But the thrill is just as good.")])]), _c('p', {
    staticClass: "C298"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("YORKSHIRE")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "P21"
  }, [_vm._v("‘Are you alright, love?’ asks a middle-aged woman with a broad Yorkshire accent, walking her terrier. She might well ask; I’m on my hands and knees, slithering into a hedge, a stone’s throw from the main road. ‘Oh I’m fine, thanks. I’m looking for a rare plant,’ I say. She and her terrier stare at me blankly. ‘I’m a botanist,’ I explain. She looks at me suspiciously. I become conscious of the twig poking out of my hair and a bleeding scratch across my forehead. ‘Right,’ she says, nodding, looking unconvinced. ‘Well then . . . good luck.’ She wanders off, looking over her shoulder. She obviously thinks I’m up to something. I hope she doesn’t call the police.")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("I can see why she’s sceptical, though. This doesn’t look like promising territory for a rare plant. Far from it. But it happens to be the best place to find a species that is very rare in the British Isles: thistle broomrape ("), _c('em', [_vm._v("Orobanche reticulata")]), _vm._v("). So rare, in fact, that it evaded botanists for centuries. Today it grows at only a handful of sites on the Magnesian limestone of north-west Yorkshire, where it appears to be associated with historic Roman roads. Although today it seems more associated with motorways. Traffic murmurs in the background.")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("Back to the task in hand. I drag myself through the scratchy hawthorn and emerge in an open parcel of grass. I look around, picking the briers out of my clothes. To my sheer delight, thistle broomrapes are pushing up their muscular spikes all around me. Some are in full bloom, with thick, liver-coloured stems bristling with rose-tinted flowers. The largest come halfway up to my knee. I spend a good 30 minutes hopping from plant to plant, crouching, crawling on all fours and generally doing what we botanists do. And as the motorway purrs in the distance – the one that cuts right through their biggest remaining colony – I think about the precarious fate of this jewel in the British flora.")])]), _c('div', {
    staticClass: "C259"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('p', {
    staticClass: "C258"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('img', {
    staticClass: "img60",
    attrs: {
      "alt": "",
      "src": "html/images/34_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "P24"
  }, [_c('em', [_vm._v("Orobanche alba")]), _vm._v(" growing out of the cliffs in County Antrim, Northern Ireland.")])])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('p', {
    staticClass: "C298"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("NORTHERN IRELAND")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "P21"
  }, [_vm._v("Today I’m accompanying the world’s leading authority on historical families, William Bortrick, for a botanical excursion around Northern Ireland. As we zip around the coast in William’s convertible, I scan the rugged landscape for unusual plants. William points out great landmarks from the car, including the sombre Garron Tower presiding over a great leafy plateau, and the historic Londonderry Arms in Carnlough, nestled in the lush Glens of Antrim – a hotel that Winston Churchill inherited from his great-grandmother, Frances Anne Vane, Marchioness of Londonderry. We stop at a small petrol station for a quick snack. Half an hour later we leave with a home-cooked lunch – you could stop at any house here and someone would happily cook you a meal. We park at a smallholding, the owner of which lives off the land quite well without electricity, and make our way wet-shod towards Northern Ireland’s north-easterly corner, Fair Head.")])]), _c('p', {
    staticClass: "P22"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("Sinking into feather-soft domes of sphagnum moss, we crouch every now and again to examine a tiny plant at our feet. The marshy land rises gently up to the brow of a steep, grey cliff. Heather and bilberry form a patchwork, carved occasionally by a lime-green lush packed with cross-leaved heath ("), _c('em', [_vm._v("Erica tetralix")]), _vm._v(") and fresh-looking ferns. Closer to the windy brink of the cliff little pink clouds of bell heather ("), _c('em', [_vm._v("Erica cinerea")]), _vm._v(") appear between the rocky outcrops. Over the cliff edge spreads a softly forested slope, scribbled at the edges with black rock that falls softly into the sea. ‘And that,’ beams William, pointing to a grey ribbon of land under a milky sky, ‘is Scotland.’ We scan the horizon towards Ballycastle and Rathlin Island and peer down at vertical rocky columns like organ pipes where wild goats roam the grassy ledges. On the shelf of a wilfully bleak cliff gleam sky-blue flashes of sheep’s bit ("), _c('em', [_vm._v("Jasione montana")]), _vm._v("). Peregrines dive over us. Cows stare at us. And William – a man who examines ")]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("people like I examine plants – asks about my childhood. I tell him of one spent with plants in IKEA car parks, and pet toads, as we weave the broken edges of this powerful grey landscape.")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "C300"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "P21"
  }, [_vm._v("‘YOU’LL STRUGGLE TO find them,’ says the groundsman, rolling his cigarette paper.")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("‘Yes, but Chris can sniff out a broomrape like a "), _c('em', [_vm._v("truffle")]), _vm._v("!’ explains William.")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("‘You’ll struggle to find those too,’ the groundsman says, licking the paper. ‘But Simeon will know where to look. He’s a ranger for the National Trust, and there isn’t a plant in Northern Ireland he doesn’t know.’")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("We ask him how we might locate Simeon.")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("‘You’ll struggle to find him,’ he mumbles, hand cupped around his cigarette. ‘He’s out on a run.’")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("We ponder this and decide perhaps it’s best to set off, take our chances. Secretly, I’m sure I can intuit the plants’ whereabouts if I’m in the area. "), _c('em', [_vm._v("Think")]), _vm._v(" like a broomrape.")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("But out on the road, as luck would have it, we see a pair of runners leaning against a car, panting.")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("‘Which one of you is Simeon?’ asks William.")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("‘Why, what’s he done?’ asks one.")])]), _c('p', {
    staticClass: "P22"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("Just at that moment Simeon himself appears, and we quiz him on his knowledge of thyme broomrape ("), _c('em', [_vm._v("Orobanche alba")]), _vm._v("). The groundsman was right, he knows precisely where the plant grows. We commit to memory his precise instructions with care, picking our way over wire fences, kissing gates and into gorse ")]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("thickets in our minds’ eyes. We thank him for his help and head east for the Causeway Coast. Forty metres east, to be precise, because just after we set off I shout, ‘"), _c('em', [_vm._v("There!’")]), _vm._v(" A stone’s throw from where we’ve discussed thyme broomrape’s rather exacting haunts, I spot the very plant sprouting out of the roadside cliff. We abandon the car in the road, to the consternation of the other drivers (‘they won’t mind, and it is an emergency of sorts,’ says William, with a sweeping gesture). We stand on the roadside and scan the imposing cliff above us.")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "P22"
  }, [_vm._v("To know a place – know it properly – you have to immerse yourself in it, don’t you? Grab it with both hands, feel its dirt beneath your fingernails. So that’s what I do. I find the indentations for finger grips and haul myself up, one ledge at a time. I examine the little rockbound patches of thyme spilling over the crags, and inch my way up, dislodging flurries of basalt. Sweat dribbles down my temples. I shout to William below that the plants are in my sights now. And suddenly I’m surrounded by them: ruby-coloured broomrapes conjured out of the rock by long days of watery sun and plumps of rain sent from the Atlantic. Their chunky little spikes jut out in clumps – some a dozen strong, with still more pushing through the rock. Their stems are the colour and texture of overripe peaches and their shapely flowers smell faintly of cloves. I spend a precious moment with them; then the growing tailback on the road below brings me back down to earth.")])]), _c('p', {
    staticClass: "P22"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("A short distance from broomrape dreamland lies the Mussenden Temple. The little domed Grecian temple is perched high above the Atlantic in front of a rose-coloured, painterly sky. William (who holds a key to every historic building in Northern Ireland!) fumbles with the locks. ‘Will you let us know when you’re in so we can join yous for a wee glass of wine?’ sings a friendly, heavily accented voice from a visitor on the path below; we all laugh at the ridiculousness of the situation. But three locks times six keys later we’re in. A magical space opens in front of ")]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("me – one that echoes cold marble, damp plaster and time. I learn that the temple was constructed in 1785 and formed part of the estate of Frederick, 4th Earl of Bristol, who served as the Church of Ireland Lord Bishop of Derry. I peer through the salt-misted windows at the rolling Atlantic that whispers through the glass. Back on the cliff the hunt for broomrapes continues against a coral sunset mist dripping into the sea.")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "P22"
  }, [_vm._v("Kelp on the breeze; moss beneath my feet; embers in the rock and embers in the sky. This was my day here.")]), _vm._v(" "), _c('p', {
    staticClass: "C298"
  }, [_vm._v("SITE NOT DISCLOSED (CLASSIFIED INFORMATION)")]), _vm._v(" "), _c('p', {
    staticClass: "P21"
  }, [_vm._v("The things I’ll do for a broomrape. The four of us slip into hi-vis vests, unfold our safety specs, clip hard hats into position and tie up our steel cap shoes beneath a pyramid of coal. It’s not how I usually dress when looking for wildflowers. We look as though we’re about to go down a mine. Fellow broomrape addict Fred Rumsey and I are here to verify a mysterious plant noticed for the first time recently by a bird ecologist called Darryl, who joins us along with our site host, Sophie. I can’t say precisely where I am because this must be kept secret – we’re on a private industrial estate and the visit has taken a month of paperwork to prepare. What I can say is that it’s about the least likely place you’d expect to see a rare plant.")]), _vm._v(" "), _c('p', {
    staticClass: "P22"
  }, [_vm._v("We inspect the map, planning our route. As with all good treasure hunts, we trace the Xs on the map that Darryl has scrawled for us. Sophie asks what time we plan to leave and we agree we’ll need a good three hours here, given the size of the site. ‘My wife’ll kill me . . .’ mutters Fred into his face covering. Decked in luminous orange PPE, we clomp along a road of graphite. It smells of hot asphalt. We pass a complicated web of industrial pipes large enough for a car to drive through, plumes of vapour, cranes and factory chimneys. Enormous, beeping, tank-like vehicles crunch along the grit, besprinkling the dust along the verges with water, leaving a stream of treacle in their wake. Everything here is black.")])]), _c('div', {
    staticClass: "C259"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('p', {
    staticClass: "C258"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('img', {
    staticClass: "img60",
    attrs: {
      "alt": "",
      "src": "html/images/39_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "P24"
  }, [_c('em', [_vm._v("Orobanche picridis")]), _vm._v(" growing on a private industrial estate.")])])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('p', {
    staticClass: "P22"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('em', [_vm._v("‘Please")]), _vm._v(" be careful!’ pleads Sophie. She could be forgiven if she is finding this a bit tiresome, as we keep darting off, leaving our hard hats in thickets and generally breaking several rules at a time – but really, bringing two botanists to such a place is asking for trouble. Fred crouches to observe some plant or other, wielding a bulky SLR camera oriented towards the road like a furtive speed camera operator lurking in the grass. The ash-black mounds along the road are flecked with blackened plants – lanky hawkweed oxtongues, rosettes of plantain, yarrow fronds – that sort of thing. Weeds are often defined as plants in the wrong place, aren’t they? Speaking of those, something else is growing here too; something unexpected.")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('p', {
    staticClass: "P22"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("‘There’s one!’ shouts Fred, happily. ‘And another,’ I chime in. Most are golden and crispy, but a handful are still clothed in fresh white flowers at the tops of their stems like teeth, all peppered with ash. That plant I courted danger with on the White Cliffs of Dover? The one I said was rare? Re-enter picris broomrape ("), _c('em', [_vm._v("Orobanche picridis")]), _vm._v(")! Hundreds of them – sprouting from every bank, siding and mound of gravel. They’re even growing out of the road. Against all the odds, we have discovered the largest population of one of Britain’s rarest plants growing in the heart of a sprawling industrial estate. We can hardly contain ourselves, hopping from one mound to another, scurrying up spoil heaps, sliding down ramps, parting tufts of grass and flinging ourselves into verges. We attract a small audience of workmen, who wander ")]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("over to see what all the fuss is about. Excitedly we show them the plant and explain why it’s so special. They peer at the browning spikes poking out of the slag. They don’t look convinced. ‘Well, that’s always been here!’ says one. ‘What about this one?’ says another, pointing to a dandelion. ‘Are they worth anything?’ says a third. Soon half the shift is wandering along the road gawking at them. Everyone is knee-deep in broomrapes.")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('p', {
    staticClass: "C251"
  }, [_c('img', {
    staticClass: "img90",
    attrs: {
      "alt": "",
      "src": "html/images/41_1.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb27d28e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/09_1__On_a_Trip_to_IKEA.vue
// module id = 81
// module chunks = 0